import React, { useContext, useEffect } from "react";
import {
  CircularProgress,
  Container,
  Typography,
  FormControlLabel,
  Link,
  Button,
  Backdrop,
  FormHelperText,
} from "@material-ui/core";
import { EmailOutlined, LockOutlined } from "@material-ui/icons";
import { path } from "ramda";
import { useHistory } from "react-router-dom";
import useFetch from "use-http";
import styled from "styled-components";
import { motion } from "framer-motion";
import { useMap, useLocalStorage } from "react-use";
import { SessionContext, Checkbox } from "../../components";
import { url } from "../../commons/env";
import Box from "../../components/Box";
import InputText from "../../components/InputText";

const getErrorMessage = path(["error", "message"]);

const Login = () => {
  const { setSession } = useContext(SessionContext);
  const history = useHistory();
  const [rememberCheck = false, setRememberCheck] = useLocalStorage(
    "remember-me"
  );
  const [rememberValue = "", setRememberValue] = useLocalStorage(
    "remember-value"
  );
  const [formState, { set: setFormValue }] = useMap({
    username: rememberCheck ? rememberValue : "",
    password: "",
  });
  const { post, loading, error, data } = useFetch(url("/auth/signin"), {
    method: "POST",
    body: {
      username: "z@fluxqr.com",
      password: "12345678",
    },
    cachePolicy: "no-cache",
  });

  const session = path(["data"], data);
  useEffect(() => {
    if (session) {
      setSession(session);
      // TODO: Get back to previous route
      history.replace("/");
    }
  }, [history, session, setSession]);

  useEffect(() => {
    setRememberValue(rememberCheck ? formState.username : undefined);
  }, [formState.username, rememberCheck, setRememberValue]);

  return (
    <Background>
      {loading && (
        <Box component={Backdrop} zIndex={2000} open>
          <CircularProgress size="5em" />
        </Box>
      )}
      <Container maxWidth="sm">
        <Box
          component="form"
          onSubmit={(e) => {
            e.preventDefault();
          }}
          mx={[1, 3, 5]}
          boxShadow={3}
          borderRadius={15}
          py={[2, 3]}
          px={[2, 3, 5]}
          display="flex"
          flexDirection="column"
          alignItems="center"
          bgcolor="lightgray.main"
        >
          <Box
            component="img"
            src="/logo.png"
            alt="Flux Logo"
            maxWidth="180px"
            mb={3}
          />
          <Typography variant="body2" align="center">
            ¡Bienvenido! Por favor inicia sesión para ingresar
          </Typography>
          <Box
            my={[2, 3]}
            alignSelf="stretch"
            display="flex"
            flexDirection="column"
            alignItems="stretch"
          >
            <Box my={[1, 2]}>
              <InputText
                name="username"
                value={formState.username}
                onChange={(e) => setFormValue("username", e.target.value)}
                Icon={EmailOutlined}
                placeholder="Usuario o email"
              />
            </Box>
            <Box my={[1, 2]}>
              <InputText
                name="password"
                value={formState.password}
                onChange={(e) => setFormValue("password", e.target.value)}
                Icon={LockOutlined}
                placeholder="Contraseña"
                type="password"
              />
            </Box>
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
            >
              <Box
                component={FormControlLabel}
                control={
                  <Checkbox
                    checked={rememberCheck}
                    onChange={() => setRememberCheck((v) => !v)}
                  />
                }
                name="remindme"
                label="Recordarme"
                m={0}
                my={[1, 2]}
              />
            </Box>
            <Box
              bgcolor="lightblue.light"
              color="lightblue.contrastText"
              alignSelf="center"
              mt={[1, 2]}
              py={1}
              px={2}
              clone
            >
              <Button
                type="submit"
                color="default"
                size="large"
                onClick={() => {
                  post({
                    username: formState.username,
                    password: formState.password,
                  });
                }}
              >
                Iniciar sesión
              </Button>
            </Box>
            {error && (
              <Box component={FormHelperText} error textAlign="center">
                {getErrorMessage(data) ||
                  "No se pudo obtener sesión con el servidor."}
              </Box>
            )}
          </Box>
        </Box>
        <Box
          component={Typography}
          align="center"
          my={2}
          color="blue.contrastText"
        >
          ¿Aún no eres parte de Flux?{" "}
          <Box
            component={Link}
            href="https://paywithflux.com/#contact"
            target="_blank"
            rel="noopener noreferrer"
            color="lightblue.main"
          >
            Contáctanos
          </Box>
        </Box>
      </Container>
    </Background>
  );
};

const backgroundTemplate = (angle, start) => `
  linear-gradient(
    ${angle}deg,
    rgb(41, 205, 237) 0%,
    rgb(41, 205, 237) ${start}%,
    rgb(24, 44, 76) ${start + 0.1}%,
    rgb(24, 44, 76) 100%
  )
`;

const Background = styled(motion.div)`
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(41, 205, 237);
`;

Background.defaultProps = {
  initial: {
    background: backgroundTemplate(180, 0),
  },
  animate: {
    background: backgroundTemplate(175, 40),
  },
  whileTap: {
    background: backgroundTemplate(176, 40),
  },
  transition: { type: "spring", damping: 6, stiffness: 50, delay: 0.3 },
};

export default Login;
